import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll } from 'services/WService.js';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const {reload} = props;

  const [dataImport, setDataImport] = useState({});
  const [sellers, setSellers] = useState([]);

  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        SlpCode: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        deposit: dataImport.data.map((item) => {
          return {
            TaxDate: moment(item.Fecha, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            account: item.Cuenta,
            description_operation: item["Descripción operación"],
            amount: item.Monto,
            operation: item["Operación - Número"].toString(),
            ref2: item.Referencia2,
          };
        }),
        SlpName: dataImport.nameFile,
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.SlpCode) {
      setDataChanging((prev) => ({
        ...prev,
        SlpCode: bPartnerSelect?.SlpCode || '',
      }));
    }
  }, [bPartnerSelect]);

    useEffect(() => {
      if (customerPortfolioB.open) {
        if (!customerPortfolioB.id);
        setDataChanging(customerPortfolioB);
      }
    }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Importar extracos bancarios`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={reload}
        arrDataResponse
        entity={'pymt/deposit/store-excel-operation'}
        dataForce={{deposit: bPartnerSelect?.deposit}}
      >
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['Monto','Cuenta','Operación - Número']}
            sortDuplicate={['MONTO','Cuenta','Operación - Número']}
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de extracto bancario`,
              fields: ['Fecha','Cuenta','Descripción operación','Monto','Operación - Número','Referencia2']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
      </Modal>
    </>
  );
});
